import type {FragmentTypesFilter} from '../extensions/csave/serverProtocolTypes'
import type {FragmentListItem} from '@wix/document-services-types/src/documentServicesModel'
import {PAGE_FRAGMENT_TYPE} from '@wix/document-manager-core'

const DEFAULT_FRAGMENT_TYPES_FILTER = {
    specificFragmentTypes: {
        fragmentTypes: [PAGE_FRAGMENT_TYPE]
    }
}

/**
 * Helper function to create fragment filter based on loadOnInit config
 * This function determines which fragment types should be loaded based on the configuration
 * and the available fragments list.
 *
 * @param dsConfig - Document services configuration containing supportedFragments
 * @param fragmentsList - List of available fragments
 * @throws {Error} When required parameters are missing
 */
export const createFragmentTypesFilter = (
    dsConfig: any,
    fragmentsList: FragmentListItem[]
): FragmentTypesFilter | undefined => {
    if (!dsConfig) {
        throw new Error('dsConfig parameter is required')
    }

    if (!dsConfig.supportedFragments || !fragmentsList || fragmentsList.length === 0) {
        return DEFAULT_FRAGMENT_TYPES_FILTER
    }

    // Get all fragment types that should be loaded based on config
    const fragmentTypesToLoad = fragmentsList
        .filter(fragment => dsConfig.supportedFragments?.[fragment.fragmentType]?.loadOnInit === true)
        .map(fragment => fragment.fragmentType)

    if (fragmentTypesToLoad.length === 0) {
        return DEFAULT_FRAGMENT_TYPES_FILTER
    }

    // Always include "Pages" as a fragment type
    const allFragmentTypes = [...fragmentTypesToLoad, PAGE_FRAGMENT_TYPE]

    // Remove duplicates + Sort for not having cache miss on different order
    const uniqueFragmentTypes = Array.from(new Set(allFragmentTypes)).sort()

    return {
        specificFragmentTypes: {
            fragmentTypes: uniqueFragmentTypes
        }
    }
}
